import { ComponentType } from 'react'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

const Wrapper = styled.span`
  position: absolute;

  ${up('sm')} {
    padding-bottom: 24px;
  }
`

interface Props {
  property: any
}

export const Promo: ComponentType<Props> = ({ property }) => (
  <Wrapper>
    {(property.promotion != null) && (
      <span className="text-white text-center text-uppercase font-size-12 property-promotion" style={{ backgroundColor: property.promotion.color }}>
        {property.promotion.name}
      </span>
    )}
  </Wrapper>
)